<template>
  <div class="rating">
    <svg
      v-for="i in 5" :key="i"
      :class="{ filled: scale >= i, half: scale > i - 1 && scale < i }"
      :asd="i"
      :width="size" :height="size" viewBox="-2 -2 20 20"
      fill="none" xmlns="http://www.w3.org/2000/svg"
    >
      <path class="first-half" d="M5.93447 5.26427L7.33664 0.948836C7.45629 0.580603 8 0.666716 8 1.0539V12.3193C8 12.5754 7.8774 12.816 7.67023 12.9665L4.11407 15.5502C3.48709 16.0057 2.64351 15.3928 2.88299 14.6558L4.18768 10.6404C4.29478 10.3107 4.17745 9.94964 3.89706 9.74593L0.481353 7.26427C-0.145617 6.80875 0.176602 5.81706 0.951581 5.81706H5.17363C5.52021 5.81706 5.82737 5.59389 5.93447 5.26427Z" />
      <path class="second-half" d="M2.06553 5.26427L0.663359 0.948836C0.543713 0.580603 0 0.666716 0 1.0539V12.3193C0 12.5754 0.122595 12.816 0.329772 12.9665L3.88593 15.5502C4.51291 16.0057 5.35649 15.3928 5.11701 14.6558L3.81232 10.6404C3.70522 10.3107 3.82255 9.94964 4.10294 9.74593L7.51865 7.26427C8.14562 6.80875 7.8234 5.81706 7.04842 5.81706H2.82637C2.47979 5.81706 2.17263 5.59389 2.06553 5.26427Z" />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    scale: { type: Number, default: 0, required: true },
    size: { type: Number, default: 20, required: false },
  },
};
</script>
<style lang="scss" scoped>
.rating svg {
  + svg {
    margin-left: 1px;
  }

  path {
    fill: var(--main-light);
    opacity: 0.43;

    &.second-half {
      // transform: translate(40%, 0);
      transform: translateX(7.75px);
    }
  }

  &.filled path,
  &.half path.first-half {
    fill: var(--main-yellow);
    opacity: 1;
  }

  &.half path.second-half {
    fill: var(--main-light);
    opacity: 0.43;
  }
}
</style>
